import { ifProp } from 'styled-tools';
import styled, { css } from 'styled-components';
import { black, grey60, grey40, grey20, red, blue20 } from 'Styles/colors';
import { fontBody } from 'Styles/fonts';

export const Input = styled.input`
  ${fontBody(16)};
  padding: 10.5px 12px;
  border-radius: 3px;
  border-style: solid;
  width: 100%;
  border-color: ${ifProp('hasError', red, grey40)};
  border-width: ${ifProp('hasError', '2px', '1px')};
  padding-left: ${ifProp('hasError', '11px', '12px')};
  color: ${black};
  outline: none;
  resize: vertical;
  margin: 0;
  appearance: none;

  &:disabled {
    background: ${grey20};
  }

  &:focus {
    border: solid 2px ${blue20};
  }

  &::placeholder {
    color: ${grey60};
  }

  ${({ hasError, isFocused, isEmpty }) => {
    if (hasError || isFocused) {
      return css`
        padding: 16px 11px 3px;
      `;
    }

    if (!isEmpty)
      return css`
        padding: 17px 12px 4px;
      `;
  }}
`;

export const Error = styled.p`
  ${fontBody(14)}
  margin: 6px 0 0 12px;
`;
